import {dashboardActions} from '../actionTypes';
import createLogger from '../../utils/createLogger';
const DEBUG = true;
const debug = createLogger(DEBUG, `dashboardActions.js`);

/** ---------------- action creators ---------------- */

const postLeadReportRequest = (config) => ({
  type: dashboardActions.POST_REPORT_LEADS_REQUEST,
  ...config,
});

const postAgenciesReportRequest = (body) => ({
  type: dashboardActions.POST_REPORT_AGENCIES_REQUEST,
  __manual: true,
  body,
});

/** ---------------- action sequences ---------------*/

const postLeadReport = (config) => {
  return (dispatch) => {
    debug.enter(`getOpenWebJobs`);
    debug.log('made it to action');
    return dispatch(postLeadReportRequest({...config}));
  }
};

const postAgenciesReport = (file) => {
  return (dispatch) => {
    let body = new FormData();
    body.append('file', file);
    return dispatch(postAgenciesReportRequest(body))
  }
};


export {
  postLeadReport,
  postAgenciesReport,
}


// WEBPACK FOOTER //
// ./src/data/dashboard/dashboardActions.js